<div class="container">

  <div class="row">
  
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-header font-weight-B fs-1r">Up</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4" ></div>
            <div class="col-md-4">
              <label for="">Admin Name / Username: </label>
              <input type="text"  class="form-control" placeholder="Admin name">
            </div>
            <div class="col-md-4" ></div>
          </div>
    
          <div class="row mt-2">
            <div class="col-md-4" ></div>
            <div class="col-md-4">
              <label for="">Admin Password : </label>
              <input type="password"  class="form-control" placeholder="Admin password">
            </div>
            <div class="col-md-4" ></div>
          </div>
    
          <div class="row mt-2">
            <div class="col-md-4" ></div>
            <div class="col-md-4">
              <label for="">Admin Type : </label>
              <select name="" id=""    class="form-control" >
                <option value="">Select Admin Type</option>
                <option value="Super Admin">Super Admin</option>
                <option value="Sub Admin">Sub Admin</option>
                <option value="Editor">Editor</option>
              </select>
  
           
  
            </div>
            <div class="col-md-4" ></div>
          </div>
    
    
          <div class="row text-center mt-3">
                  <div class="col-md-12">
                    <button  c class="btn-wide mb-2 me-2 btn btn-primary">Add Admin
                    </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  
        </div>
  
  
  
  
  
  
  </div>

<div class="imageMainDiv">
    <label for="inputTag">
      Select CSV File <br/>
      <img src="../../assets/images/csv.png"  height="90px" alt="">
      <input id="inputTag" type="file" class="input_file"  (change)="getCSV_withoutLock($event)"  />
      <br/>
      <span id="imageName"></span>
    </label>
    
  </div>